"use client";

// Microsoft Clarity — free session recordings + heatmaps.
//
// Gated on NEXT_PUBLIC_CLARITY_ID: with no ID this renders nothing. Clarity
// tracks SPA navigations on its own, so no manual route-change handling needed.
// Sign up free at clarity.microsoft.com to get the project ID.
import Script from "next/script";

const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID || "";

export default function MicrosoftClarity() {
  if (!CLARITY_ID) return null;

  return (
    // lazyOnload 同 GoogleAnalytics.js — 讓出 hydration 期主執行緒
    <Script id="ms-clarity" strategy="lazyOnload">
      {`
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${CLARITY_ID}");
      `}
    </Script>
  );
}
